const palette = {
  primary: {
    contrastText: '#fff',
    dark: '#26235c',
    light: '#44a9df',
    main: '#1070b3',
  },
  secondary: {
    contrastText: '#fff',
    dark: '#44a9df',
    light: '#8fc5e8',
    main: '#C0e2f7',
  },
};

export default palette;
